const fightingArts = [
    {
        "name": "Ambidextrous",
        "definition": "All melee weapons in your gear grid gain paired. Ambidextrous cannot be used if there are any shields, two-handed, or heavy gear in your gear grid.",
        "notes": "The two weapons activated must still have the same name, following the rules of the paired keyword. A character cannot pair two different weapon gear cards together.",
        "expansion": "core"
    },
    {
        "name": "Berserker",
        "definition": "Once per showdown, you may spend Activation to suffer bash and the frenzy brain trauma.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Clutch Fighter",
        "definition": "While you have 3 or more bleeding tokens, gain +1 strength and +1 accuracy.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Combo Master",
        "definition": "On a perfect hit make 1 additional attack roll.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Crazed",
        "definition": "On a perfect hit, gain +1 insanity.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Crossarm Block",
        "definition": "Whenever you are hit, after hit locations are rolled, you may change 1 result to the arms hit location.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Double Dash",
        "definition": "During your act, once per round, you may spend Activation to gain Movement.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Extra Sense",
        "definition": "You may dodge 1 additional time per round.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Last Man Standing",
        "definition": "While you are the only survivor on the showdown board, you may not gain bleeding tokens or be knocked down.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Leader",
        "definition": "Whenever you encourage a survivor, they gain +1 speed token until the end of the round. Once per hunt phase, you may inspire another survivor. They use your understanding and courage to resolve a hunt or story event.",
        "notes": "Example: if you have 3+ courage you can inspire another survivor to walk the path of the brave during Overwhelming Darkness.",
        "expansion": "core"
    },
    {
        "name": "Mighty Strike",
        "definition": "On a perfect hit, gain +2 strength until the end of the attack.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Monster Claw Style",
        "definition": "Your Fist & Tooth attacks gain +1 accuracy, +1 strength and savage.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Orator of Death",
        "definition": "Once per showdown, you may spend Activation to have all non-deaf survivors gain +2 insanity. When you die, you encourage all survivors with your last words.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Rhythm Chaser",
        "definition": "On Arrival, gain +1 evasion token. When you are knocked down, if you don't have an instrument in your gear grid, remove all your +1 evasion tokens. Rhythm Chaser cannot be used if there is any heavy gear in your gear grid.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Strategist",
        "definition": "During the showdown setup, after placing terrain, you may add a Giant Stone Face or a Toppled Pillar terrain card to the showdown board.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Thrill Seeker",
        "definition": "Whenever you gain survival during the showdown phase, gain 1 additional survival.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Timeless Eye",
        "definition": "Your attack roll is a perfect hit on a result of 9 or 10. You cannot use Timeless Eye if you have the blind severe head injury.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Tough",
        "definition": "When rolling on a severe injury table, unless you roll a 1, add +1 to the result. (This does not include brain trauma. The result cannot exceed 10.)",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Tumble",
        "definition": "When something would collide with you, roll 1d10. On a result of 6+, you successfully tumble out of harms way. Instead, place your survivor standing on the closest free space outside of the collision path.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Unconscious Fighter",
        "definition": "It takes 7 bleeding tokens to kill you.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Acrobatics",
        "definition": "When you are adjacent to the monster, you may spend Movement to place your survivor on any other space adjacent to the monster.",
        "notes": null,
        "expansion": "Dragon King"
    },
    {
        "name": "Champion's Rite",
        "definition": "Before making an attack, you may add your understanding to your accuracy attribute for that attack. Limit, once per showdown.",
        "notes": null,
        "expansion": "Dragon King"
    },
    {
        "name": "Fated Blow",
        "definition": "Once per showdown, you may give your next wound attempt +2 strength and Devastating 1.",
        "notes": null,
        "expansion": "Dragon King"
    },
    {
        "name": "Unbreakable",
        "definition": "Once per lantern year, you may ignore one of your severe injury roll results. If you do, gain a random disorder.",
        "notes": null,
        "expansion": "Dragon King"
    },
    {
        "name": "Carapace of Will",
        "definition": "On Arrival, gain the Steadfast survivor status card. When you are attacked, if you have 2+ steadfast tokens, ignore a hit and remove all your steadfast tokens.",
        "notes": null,
        "expansion": "Dung Beetle Knight"
    },
    {
        "name": "Propulsion Drive",
        "definition": "On Arrival, gain the Momentum survivor status card. When you attack, if you have 5+ momentum tokens, remove them all and roll 1d10. Gain that amount of luck and strength when attempting to wound the first selected hit location for this attack.",
        "notes": null,
        "expansion": "Dung Beetle Knight"
    },
    {
        "name": "Otherworldly Luck",
        "definition": "During the hunt and settlement phase, whenever you roll on a table, you may add +1 to the roll result. This may not exceed the highest possible result of that table. (This includes Hunt Events, Story Events, Endeavors, Settlement Events, etc)",
        "notes": null,
        "expansion": "Flower Knight"
    },
    {
        "name": "Bloodzerker",
        "definition": "Gain +1 strength for each of your bleeding tokens. When you have 3+ bleeding tokens, you lose yourself to the blood and are guardless!",
        "notes": null,
        "expansion": "Crimson Crocodile"
    },
    {
        "name": "Glass Mask",
        "definition": "When you depart, you lightly cut your ears, rub blood all over your face, and wait for it to dry. Gain +3 insanity. If you have Face Painting, you create a seal between your glass mask and your armor. Gain an additional +3 insanity.",
        "notes": null,
        "expansion": "Crimson Crocodile"
    },
    {
        "name": "Invigorator",
        "definition": "Gain +1 accuracy and +1 speed while you have no insanity.",
        "notes": null,
        "expansion": "Crimson Crocodile"
    },
    {
        "name": "Lure Epilepsy",
        "definition": "Once per showdown, you may spend Activation to give yourself a seizure. You suffer a random brain trauma and are knocked down.",
        "notes": null,
        "expansion": "Gorm"
    },
    {
        "name": "Mammoth Hunting",
        "definition": "Gain +1 strength when attacking from adjacent spaces outside the monster's facing and blind spot.",
        "notes": null,
        "expansion": "Gorm"
    },
    {
        "name": "Burning Focus",
        "definition": "If you have 0 survival at the start of your act, gain 1 survival.",
        "notes": null,
        "expansion": "Lion God"
    },
    {
        "name": "Heroic",
        "definition": "Once per showdown, if you are standing adjacent to the monster and have 3+ survival, you may spend all of your survival for one automatic hit that inflicts a critical wound.",
        "notes": null,
        "expansion": "Lion God"
    },
    {
        "name": "Ruthless",
        "definition": "Whenever a survivor dies during the showdown, roll 1d10. On a 7+, gain a Skull basic resource.",
        "notes": null,
        "expansion": "Lion God"
    },
    {
        "name": "Unrelenting",
        "definition": "If all of your attack rolls in an attack miss, you may spend 1 survival to re-roll all attack rolls.",
        "notes": null,
        "expansion": "Lion God"
    },
    {
        "name": "Headliner",
        "definition": "When you become doomed or gain the priority target token, you may choose to gain +1 survival or +1 strength token.",
        "notes": null,
        "expansion": "Lion Knight"
    },
    {
        "name": "Tenacious",
        "definition": "When your wound attempt on a hit location is a failure, you may put that hit location back on top of the deck instead of in the discard pile. Limit, once per round.",
        "notes": null,
        "expansion": "Lion Knight"
    },
    {
        "name": "Wardrobe Expert",
        "definition": "When you suffer a severe injury at a hit location, you may archive a gear worn at that location to ignore it and gain +1 survival.",
        "notes": null,
        "expansion": "Lion Knight"
    },
    {
        "name": "Abyssal Sadist",
        "definition": "The first time you wound the monster each attack, gain +1 survival and +1 insanity. Ignore the effects of the Fear of the Dark and Prey disorders.",
        "notes": null,
        "expansion": "Manhunter"
    },
    {
        "name": "Seasoned Hunter",
        "definition": "Whenever a random hunt event result is: 11, 22, 33, 44, 55, 66, 77, 88, 99, or 100, the event revealer gains +1 understanding and +1 courage.",
        "notes": null,
        "expansion": "Manhunter"
    },
    {
        "name": "Trailblazer",
        "definition": "The hunting party may start the hunt phase 1 space closer to the monster. At the start of the showdown, all survivors gain +1 survival and up to +1 insanity.",
        "notes": null,
        "expansion": "Manhunter"
    },
    {
        "name": "Transcended Masochist",
        "definition": "When you gain a bleeding token, gain +1 survival and +1 insanity. Ignore the effects of the Aichmophobia and Apathetic disorders.",
        "notes": "The artwork for Transcended Masochist features the survivor Breccia found in the White Gigalion vignette.",
        "expansion": "Manhunter"
    },
    {
        "name": "Blotted Out",
        "definition": "Whenever you suffer a brain trauma, gain a bleeding token.",
        "notes": null,
        "expansion": "Slenderman"
    },
    {
        "name": "Temp",
        "definition": "The first time you gain a resource during a showdown, you may feed it to your phantom friend. If you do, archive the resource and gain +1 evasion token. Lose this token if you are deaf or become deaf during the showdown.",
        "notes": null,
        "expansion": "Slenderman"
    },
    {
        "name": "Harvestman",
        "definition": "Gain +3 movement. Whenever you are knocked down, gain -1 movement token. If you have the Tiny Arachnophobia disorder, you are too scared of spiders to imitate them and you cannot use this fighting art.",
        "notes": null,
        "expansion": "Spidicules"
    },
    {
        "name": "Vengeance",
        "definition": "When a survivor dies during the showdown, gain +4 survival and +1 strength token.",
        "notes": null,
        "expansion": "Spidicules"
    },
    {
        "name": "Burning Ambition",
        "definition": "When you are instructed to skip the next hunt, ignore it. The 'Skip Next Hunt' box on your survivor record sheet cannot be filled in.",
        "notes": null,
        "expansion": "Sunstalker"
    },
    {
        "name": "Defender",
        "definition": "When a survivor adjacent to you is knocked down, you may spend 1 survival. If you do, they stand and gain +1 survival from your words of encouragement. You cannot use this if you have the shattered jaw severe injury.",
        "notes": null,
        "expansion": "Sunstalker"
    },
    {
        "name": "Purpose",
        "definition": "Your comrades make you strong enough to exceed the limits of death itself. During the showdown, if you would gain a lethal number of bleeding tokens while there are any other standing survivors, roll 1d10. On a 6+, you live but are knocked down. You will not bleed to death until you gain another bleeding token.",
        "notes": null,
        "expansion": "Sunstalker"
    },
    {
        "name": "Sneak Attack",
        "definition": "When you attack a monster from its blind spot, gain +4 strength for that attack.",
        "notes": null,
        "expansion": "Sunstalker"
    },
    {
        "name": "Trick Attack",
        "definition": "Once per showdown, when you wound a monster from its blind spot, a survivor adjacent to you may gain the priority target token.",
        "notes": null,
        "expansion": "Sunstalker"
    },
];


export default fightingArts;